import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=2004b197&"
import script from "./forgot-password.vue?vue&type=script&lang=ts&"
export * from "./forgot-password.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports